module.exports = __webpack_public_path__ + "img/shortlisted-icon.0e777498.svg";